export default __webpack_public_path__ + "static/media/Tunic of the Unutterable.30312e80.jpg";